import type React from 'react';

import PageBackButton from './components/PageBackButton';
import PageBody from './components/PageBody';
import PageFilters from './components/PageFilters';
import PageFooter from './components/PageFooter';
import PageHeader from './components/PageHeader';
import PageTabs from './components/PageTabs';

export interface PageProps {
  children: React.ReactNode;
}

const Page = ({ children }: PageProps) => {
  return (
    <div className='m-5 mb-20 box-border flex min-h-[calc(100%-100px)] flex-col space-y-4 rounded-md bg-white p-5 pb-0 shadow shadow-gray/20'>
      {children}
    </div>
  );
};

Page.BackButton = PageBackButton;
Page.Header = PageHeader;
Page.HeaderTitle = PageHeader.Title;
Page.HeaderActions = PageHeader.Actions;
Page.Filters = PageFilters;
Page.Tabs = PageTabs;
Page.Body = PageBody;
Page.Footer = PageFooter;

export default Page;
